import { NgModule } from '@angular/core';

import { EmptyStringPipe } from './columns.pipe';
import { StringCapitalize } from './string-capitalize.pipe';
import { UTCDiff } from './utc-diff.pipe';
import { UTCDetailDiff } from './utc-diff.pipe';
import {SecondsToDurationPipe} from './seconds-to-duration.pipe';
import {BytesToMegabytesPipe} from './bytes-to-megabytes.pipe';

@NgModule({
    imports: [],
    declarations: [
        UTCDiff,
        UTCDetailDiff,
        StringCapitalize,
        EmptyStringPipe,
        SecondsToDurationPipe,
        BytesToMegabytesPipe
    ],
    providers: [],
    exports: [
        UTCDiff,
        UTCDetailDiff,
        StringCapitalize,
        EmptyStringPipe,
        SecondsToDurationPipe,
        BytesToMegabytesPipe
    ]
})
export class PipesModule { }



// WEBPACK FOOTER //
// ./src/app/pipes/pipes.module.ts